import React from 'react'

import useRect from '../hooks/useRect'
import BarStacked from '_components/audience-insights/charts/bar-stacked/index.jsx'
import { largestRemainderRound } from '../../charts/helpers/formatters'

function BarStackedHOC({ data }) {
  const [Rect, rect] = useRect()

  const rounded = data.map((item) => {
    const items = [item?.negative ?? 0, item?.neutral ?? 0, item?.positive ?? 0]
    if (items.every((i) => i === 0)) {
      return {
        labels: item.labels,
        negative: 0,
        neutral: 0,
        positive: 0,
      }
    }
    const [negative, neutral, positive] = largestRemainderRound(items)
    return {
      labels: item.labels,
      negative,
      neutral,
      positive,
    }
  })

  return (
    <>
      <Rect />
      <foreignObject
        x="0"
        y="0"
        width={rect.width}
        height={rect.height}
        data-custom-render="ai-chart-bar-stack"
        data-json={JSON.stringify(rounded)}
      >
        <BarStacked data={rounded} width={rect.width} height={rect.height} />
      </foreignObject>
    </>
  )
}

export default BarStackedHOC
